<div class="arm-table">
    <div class="arm-table-container" #tableMainContainer>
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="dataDirection($event)" [matSortActive]="matSortActive()"
               [matSortDirection]="'asc'">
            <ng-container *ngFor="let col of displayedColumns" [matColumnDef]="col.name">
              <ng-container *ngIf="col.sort">
                <th mat-header-cell (mousedown)="onResizeColumn($event)"
                    *matHeaderCellDef mat-sort-header="{{col.name}}" [disableClear]="true"> {{col.display | uppercase}} </th>
                <td mat-cell armEllipsisTooltip
                    [innerHTML]="getCellTemplate(element, col.name, col.path, col.transformer)"
                    *matCellDef="let element"></td>
              </ng-container>
              <ng-container *ngIf="!col.sort">
                <th mat-header-cell (mousedown)="onResizeColumn($event)"
                    *matHeaderCellDef > {{col.display | uppercase}} </th>
                <td mat-cell armEllipsisTooltip
                    [innerHTML]="getCellTemplate(element, col.name, col.path, col.transformer)"
                    *matCellDef="let element"></td>
              </ng-container>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="getDisplayedColumns(); sticky: true"></tr>
            <tr mat-row (click)="onItemClicked(row, $event); selectionChanged(selection)"
                [ngClass]="{hovered: row.hovered, highlighted: selection.isSelected(row)}"
                *matRowDef="let row; columns: getDisplayedColumns();">
            </tr>
        </table>
    </div>
    <div class="arm-table-footer">
        <mat-paginator *ngIf="isPagedTable"
                       [length]="length"
                       [pageSize]="pageSize"
                       [pageSizeOptions]="pageSizeOptions"
                       showFirstLastButtons
                       aria-label="Select page">
        </mat-paginator>

        <cursor-paginator *ngIf="isCursorPageTable" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                          (cursorPageChanged)="cursorPageChanged($event)" [pageEventCursor]="pageEventCursor">
        </cursor-paginator>
    </div>
</div>
